import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowApplicationForm from "@sourceflow-uk/sourceflowapplicationform";
import {
    Card,
    Col,
    Row,
    Container,
    List,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import styles from './styles.module.scss';
import JobConsultant from '../JobConsultant';
import SimilarJobs from '../SimilarJobs';
import { format } from "date-fns";
import Cookies from "js-cookie";
import { trackMetaEvent } from "../../functions/metaPixel";
import { getJobApplyUrl } from "../../functions/getJobApplyUrl";

export default function JobDetails({
    global,
    pathPrefix,
    heading,
    leftHeading,
    job,
    sector,
    job_type,
    base_salary_range,
    similarJob,
    branchId,
    sub_content
}) {
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const toBold = text => {
        const charSet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '!', '?', '.', ',', '"', "'"];
        const targetCharSet = ['𝗮', '𝗯', '𝗰', '𝗱', '𝗲', '𝗳', '𝗴', '𝗵', '𝗶', '𝗷', '𝗸', '𝗹', '𝗺', '𝗻', '𝗼', '𝗽', '𝗾', '𝗿', '𝘀', '𝘁', '𝘂', '𝘃', '𝘄', '𝘅', '𝘆', '𝘇', '𝗔', '𝗕', '𝗖', '𝗗', '𝗘',
            '𝗙', '𝗚', '𝗛', '𝗜', '𝗝', '𝗞', '𝗟', '𝗠', '𝗡', '𝗢', '𝗣', '𝗤', '𝗥', '𝗦', '𝗧', '𝗨', '𝗩', '𝗪', '𝗫', '𝗬', '𝗭', '𝟬', '𝟭', '𝟮', '𝟯', '𝟰', '𝟱', '𝟲', '𝟳', '𝟴', '𝟵', '❗', '❓', '.', ', ', '"', "'"]; const textArray = text.split('');
        let boldText = '';
        textArray.forEach((letter) => {
            const index = charSet.findIndex((_letter) => _letter === letter);
            if (index !== -1) {
                boldText = boldText + targetCharSet[index];
            } else {
                boldText = boldText + letter;
            }
        });
        return boldText;
    }
    const country = job.location.split(",")[0];
    const job_location = job.location;
    const region = job.location.split(",")[1];
    const body =
        `Hi` + `\n\n` +
        `Gap Personnel is hiring for the following opportunity:` + `\n\n` +
        toBold(job.title) + ` - ` + toBold(job.location) + ' \n\n'

    const filtered_sector = require("uniq")(sector)

    // const jobApplyUrl = `https://candidates.gap-personnel.com/#/welcome?fxbranch=${branchId}&job_id=${parseInt(job.id.split('-')[0], 16)}&job_ref=${job.external_reference}&job_title=${job.title}`

    const [jobApplyUrl, setJobApplyUrl] = useState(getJobApplyUrl({ job, branchId, jobType: job_type }));

    useEffect(() => {
        const sfsource = Cookies.get('_sf_source')

        if(sfsource){
            const parts = sfsource.split('|')

            const referrer = parts[0]?.replace('referrer:', '')
            const utm_source = parts[1]?.replace('utm_source:', '')
            const utm_medium = parts[2]?.replace('utm_medium:', '')
            const utm_campaign = parts[3]?.replace('utm_campaign:', '')

            let newUrl = jobApplyUrl + `&referrer=${referrer}&utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`;
            setJobApplyUrl(newUrl);
        }
        
    }, []);

    return (
        <>
            <div className={`${styles.root}`}>
                <Container>
                    <Row>
                        <Col lg={3}>
                            <div className="job-details rounded-3 overflow-hidden border">
                                <div className="p-4">
                                    <h5 className="heading mb-4">
                                        <strong>
                                            <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle`}>
                                                {leftHeading}
                                            </SourceFlowText>
                                        </strong>
                                    </h5>

                                    <List type="unstyled">
                                        {country != "" ?
                                            <li className="mb-3">
                                                <small><label><strong>Location:</strong></label> {job_location}</small>
                                            </li> : null}
                                        {base_salary_range != "" ?
                                            <li className="mb-3">
                                                <small><label><strong>Salary:</strong></label> {base_salary_range}</small>
                                            </li> : null}
                                        {job_type != "" ?
                                            <li className="mb-3">
                                                <small> <label><strong>Type:</strong></label> {job_type}</small>
                                            </li> : null}
                                        {filtered_sector != "" ?
                                            <li className="mb-3">
                                                <small><label><strong>Specialty:</strong></label> {filtered_sector}</small>
                                            </li> : null}
                                        {job.external_reference ?
                                            <li className="mb-3">
                                                <small> <label><strong>Ref:</strong></label> {job.external_reference}</small>
                                            </li> : null}
                                        {job.published_at ?
                                            <li className="mb-3">
                                                <small><label><strong>Posted:</strong></label> {format(new Date(job?.published_at), 'dd/MM/Y')}</small>
                                            </li> : null}
                                        {/* {job?.salary_package ?
                                        <li>
                                            <label><strong>Salary:</strong></label> {job.salary_package}
                                        </li> : null} */}
                                        {/* {region ?
                                    <li>
                                        <label><strong>Region:</strong></label> {region}
                                    </li> : null} */}

                                    </List>
                                </div>
                                <JobConsultant
                                    global={global}
                                    pathPrefix={pathPrefix}
                                    customClass="job-consultant p-4"
                                    jobId={job.id}
                                    emailText={`Email`}
                                    heading={`Contact`}
                                />
                            </div>
                        </Col>
                        <Col lg={6} className="ps-lg-4 pe-lg-4 pt-4" >
                            <h5 className="heading mb-4">
                                <strong>
                                    <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle`}>
                                        {heading}
                                    </SourceFlowText>
                                </strong>
                            </h5>
                            {job?.description ?
                                <div className="description" dangerouslySetInnerHTML={{ __html: job?.description }} />
                                : ""}
                            <SourceFlowText global={global} path={`${pathPrefix}.sub_content`}>
                                <i>{sub_content}</i>
                            </SourceFlowText>
                            {/*<div className="mt-5 mb-5 p-lg-5 p-4 job-application-wrapper rounded-3 border" id="job-application">
                                <SourceFlowApplicationForm onSubmitDone={() => window.location.href = '/jobs/thank-you-for-your-application'} jobId={job.id} />
                            </div>*/}
                            <div id="job-application">
                                <a href={jobApplyUrl} onClick={() => trackMetaEvent("SubmitApplication", { content_name: job?.title })} className="primaryBtn secondary-color text-white m-0">Apply Now</a>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <SimilarJobs
                                global={global}
                                pathPrefix={pathPrefix}
                                customClass="ps-lg-4 p-0 mt-4 mt-lg-0"
                                heading={`Similar Jobs`}
                                all_similarJob={similarJob}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}